<div class="region-container">
  <div class="row">
    <div class="col-12 col-md-3 order-2 ">
      <div class="d-flex flex-column project-info" *ngIf="selectedModel">
        <h4 class="project-title">{{ selectedProjectModel?.projectName }}</h4>
        <p class="project-details" [innerText]="selectedProjectModel?.projectNumber"></p>
      </div>
    </div>
    <div class="col-12 col-md-6  order-md-2">
      <div *ngIf="client" class="justify-content-center d-flex">
        <app-breadcrumb-navigation
          [items]="currentPath"
          (pressedItemIndex)="navigateTo($event)"
          (nodeSelected)="selectNode($event)"
          (modelSelected)="selectModel($event)"
        />
      </div>
    </div>
  </div>

  <br />

  <ng-container *ngIf="!selectedModel">
    <ng-container *ngIf="!loadingModelDetails">
      <div class="row header-section mb-5 align-items-center">
        <!-- Left spacer column -->
        <div class="col-3"></div>

        <!-- Center column for "Choose the ..." -->
        <div class="col-6 text-center">
          <div class="title">
            <span>
              Choose the
              <ng-container *ngIf="!selectedModels">
                <span>{{ toTitleCase(selectedLevel?.[0]?.name ?? 'Address') }}</span>
              </ng-container>
              <ng-container *ngIf="selectedModels">
                <span>{{ getClientLastNodeName() }}</span>
              </ng-container>
            </span>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- No Models Message -->
    <div *ngIf="!hasAnyModels()" class="no-models-message mb-5">
      <div class="alert">
        <div class="message-content">
          <div class="icon">📂</div>
          <h3 class="title">No Models Available</h3>
          <p class="description">You do not have any models yet or do not have permission to them</p>
        </div>
      </div>
    </div>

    <!-- Filter button and filter active message -->
    <div class="text-left mt-4 d-flex justify-content-between" *ngIf="selectedModels && showFilters()">
      <div class="col-md-6 text-left">
        <div class="container-fluid d-flex h-20 flex-wrap align-items-center">
          <button class="btn btn-outline rounded-circle border-0" (click)="toggleFilters()" ngbTooltip="Show/Hide Filter">
            <i [ngClass]="isFilterSectionVisible ? 'bi bi-funnel-fill' : 'bi bi-funnel'"></i>
          </button>
          <div class="col-md-6 text-left mb-3" *ngIf="isFilterActive()">
            <span class="text-warning">Filters are active</span>
          </div>
        </div>
      </div>
    </div>

    <!-- View All -->
    <div class="wrapper mb-5" *ngIf="!selectedModels">
      <div *ngFor="let node of selectedLevel" class="element">
        <div class="card-wrapper">
          <app-card
            class="card-component"
            [card]="mapNodeToCard(node)"
          ></app-card>
        </div>
      </div>
    </div>


    <!-- Filter -->
    <div class="selected-models-section filter-section" *ngIf="selectedModels && showFilters() && isFilterSectionVisible">
      <h5 class="col-12  mt-1 mb-1">Filter:</h5>

      <!-- Divider -->
      <hr class="col-12 mt-1 vertical-align-top">


      <div class="row col-12 align-items-center justify-content-center" >
        <!-- Dynamic filter options based on model subOptions -->
        <ng-container  *ngFor="let filterKey of getFilterKeys(); let i = index">
          <div class="col-12 col-md-3 col-sm-12 col-lg-3 mb-3">
            <label [for]="'filter-' + filterKey">{{ filterKey | titlecase }}</label>
            <select [name]="filterKey" [id]="'filter-' + filterKey" (change)="onFilterChange(filterKey, $event)" [value]="activeFilters[filterKey]">
              <option *ngFor="let value of getFilterValues(filterKey)" [value]="value" [selected]="activeFilters[filterKey] === value">{{ value }}</option>
            </select>
          </div>

        </ng-container>

              <!-- Search By Name -->
              <div class="col-12 col-md-3 col-lg-3  mb-3">
                <label for="filter-search"><strong>Search by name</strong></label>
                <input type="text" name="search" id="filter-search"   [(ngModel)]="searchText" (input)="onSearchChange($event)">
              </div>

        <!-- Reset Button -->
        <button class="col-12 col-sm-12 col-md-3 col-lg-3   btn btn-secondary border-0 "  style="white-space: nowrap; background-color: transparent;"
        (click)="resetFilters()" [disabled]="!isFilterActive()">
          <i class="bi bi-x-circle me-1"></i>Reset Filters
        </button>




      </div>
    </div>

    <!-- View Models -->
    <div class="wrapper mb-5" *ngIf="selectedModels && !loadingModelDetails">
      <div *ngFor="let model of paginatedModels" class="element">
        <div class="card-wrapper">
          <app-card
            class="card-component"
            [card]="mapModelToCard(model)"
          ></app-card>
        </div>
      </div>
    </div>

    <!-- Pagination controls -->
    <div class="d-flex justify-content-center mb-4" *ngIf="totalPages > 1">
      <nav aria-label="Page navigation">
        <ul class="pagination">
          <!-- Previous button -->
          <li class="page-item" [class.disabled]="currentPage === 1">
            <a class="page-link" (click)="previousPage()" aria-label="Previous">
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>

          <!-- Page numbers -->
          <ng-container *ngFor="let pageNum of getPageNumbers()">
            <li *ngIf="pageNum !== -1" class="page-item" [class.active]="pageNum === currentPage">
              <a class="page-link" (click)="goToPage(pageNum)">{{ pageNum }}</a>
            </li>
            <li *ngIf="pageNum === -1" class="page-item disabled">
              <a class="page-link">...</a>
            </li>
          </ng-container>

          <!-- Next button -->
          <li class="page-item" [class.disabled]="currentPage === totalPages">
            <a class="page-link" (click)="nextPage()" aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>

    <div *ngIf="filteredModels && filteredModels.length === 0" class="no-models-message mb-5">
      <div class="alert">
      <div class="message-content">
        <div class="icon">📂</div>
        <h3 class="title">No Results Found</h3>
        <p class="description">Try adjusting your filters or search criteria</p>
      </div>
      </div>
    </div>


  </ng-container>

  <div *ngIf="selectedModel">
    <app-bom-table
      [data]="selectedModel"
      [model]="selectedProjectModel"
    ></app-bom-table>
  </div>
</div>
